var map = {
	"./arrow-down-blue.svg": 388,
	"./arrow-down-grey.svg": 389,
	"./arrow-right-white.png": 390,
	"./arrow-right.svg": 391,
	"./big_unicorn.png": 161,
	"./blue-loader.svg": 117,
	"./checkmark.png": 168,
	"./circle-grey.svg": 392,
	"./circle.svg": 393,
	"./coinbaseWalletIcon.svg": 118,
	"./dropdown-blue.svg": 394,
	"./dropdown.svg": 395,
	"./dropup-blue.svg": 396,
	"./ethereum-logo.png": 169,
	"./fortmaticIcon.png": 119,
	"./link.svg": 397,
	"./magnifying-glass.svg": 398,
	"./menu.svg": 399,
	"./metamask.png": 167,
	"./noise.png": 163,
	"./plus-blue.svg": 400,
	"./plus-grey.svg": 401,
	"./portisIcon.png": 120,
	"./question-mark.svg": 402,
	"./question.svg": 403,
	"./socks-logo.png": 170,
	"./spinner.svg": 404,
	"./token-list/lists-dark.png": 405,
	"./token-list/lists-light.png": 406,
	"./token-logo.png": 116,
	"./token-logo.svg": 407,
	"./trustWallet.png": 408,
	"./unisocks1.png": 122,
	"./unisocks2.png": 409,
	"./walletConnectIcon.svg": 121,
	"./x.svg": 410,
	"./xl_uni.png": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;